module.exports = __webpack_public_path__ + "static/media/today.ea1119a6.svg";